import { createFileRoute } from "@tanstack/react-router";
import {
  dailyBonusQueryOptions,
  fukadaEventCampaignScheduleQueryOptions,
} from "~/features/dailyBonus/api";
import { DailyBonusTemplate } from "~/features/dailyBonus/DailyBonusTemplate";
import { captureError } from "~/lib/sentry/captureError";

export const Route = createFileRoute("/_authenticated/daily-bonus")({
  // claim(utage_web_daily_bonus)を含むため、hover プリロードでは loader を発火させない。
  // 実ナビゲーション時のみ claim を叩く（Link hover で受取が消費され、本表示で
  // add_point=0 になりモーダルが出ない、という二重発火を防ぐ）。
  preload: false,
  // キャッシュ優先の ensureQueryData ではなく fetchQuery を使う。staleTime:0 と組み合わせ、
  // 再訪のたびフレッシュに claim を叩き直す（サーバが日次 idempotent）。
  loader: async ({ context: { queryClient } }) => {
    const [dailyBonusResult] = await Promise.all([
      queryClient.fetchQuery(dailyBonusQueryOptions),
      // 受取モーダルのアイコン出し分け用。claim とは独立の非クリティカルな情報なので、
      // 失敗してもページ遷移はブロックしない（Sentry には送る）。マウント前に fetch し
      // 終えておくことで、モーダル初回表示時のアイコンのちらつき（P コイン→えいみ画像）を防ぐ。
      (async () => {
        try {
          await queryClient.ensureQueryData(
            fukadaEventCampaignScheduleQueryOptions,
          );
        } catch (err) {
          captureError(
            err,
            "daily-bonus route loader: get_fukada_event_campaign_schedule 取得失敗",
          );
        }
      })(),
    ]);
    return dailyBonusResult;
  },
  component: DailyBonusTemplate,
});
